import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseOrder, Status } from '../../../models/orders.model';

export interface Filter {
  [key: string]: string;
}

@Injectable(
  {
    providedIn: 'root'
  }
)

export class DataFetchService {
  http = inject(HttpClient);

  getData<T>(path: string, filter?: Filter | void): Observable<T> {
    let params = new HttpParams();
    // Add filter parameters to the query string if provided    
    if (filter) {
      Object.keys(filter).forEach(key => {
        // Check if the filter value is an array and append it accordingly
        if (Array.isArray(filter[key])) {
          filter[key].forEach(value => {
            params = params.append(key, value);
          });
        } else {
          params = params.append(key, filter[key]);
        }
      });
    }


    // Ensure consistent extraction of the body
    return this.http.get<T | { body: T }>(path, { params }).pipe(
      map(response => {
        // If response has a 'body' property, return it; otherwise, return the response directly
        if (response && typeof response === 'object' && 'body' in response) {
          return (response as { body: T }).body;
        }
        return response as T;
      })
    );
  }


  getOrders(filter?: Filter | void): Observable<BaseOrder[]> {
    const defaultFilter: { [key: string]: string } = {
      startDate: "2025-01-01",
      endDate: "2026-01-01"
    };
    if (filter) {
      Object.keys(filter).forEach(key => {
        defaultFilter[key] = filter[key];
      });
    }

    return this.getData<BaseOrder[]>(`${environment.API_LOCATION}/connectivity/gateway/getOrders`, defaultFilter);
  }
  //**** By REST API design call the single id directly as URL and not query param */
  getSingleOrder(orderId: string): Observable<BaseOrder> {
    return this.getData<BaseOrder>(`${environment.API_LOCATION}/connectivity/gateway/getOrder`, {orderId});
    //return this.getData<BaseOrder[]>('assets/parts.json', filter);
  }

  updateOrderStatus(orderId: string, newStatus: Status) {

    const url = `${environment.API_LOCATION}/connectivity/gateway/updateExternOrder`;
    const data = {
      orderId: parseFloat(orderId),
      orderStatus: newStatus
    }
    return this.http.post<BaseOrder>(url, data);

  }
}
